// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Thumbnail{margin-top:1em}.Thumbnail-image{border:5px solid rgba(0,0,0,.05);box-shadow:1px 1px 3px rgba(0,0,0,.15);box-sizing:border-box;cursor:zoom-in;max-width:100%}.Thumbnail-caption{color:rgba(0,0,0,.75);font-size:.9em;font-style:italic;margin-top:.25em;text-decoration:none}", ""]);
// Exports
module.exports = exports;
